import { Component, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Refresher, NavController } from 'ionic-angular';
import { PromoProductsService } from '../../providers/promo-products/promo-products.service';
import { PromoProductHistory } from '../../interfaces/PromoProduct.interface';
import { ApiErrorHandlerProvider } from '../../providers/api-error-handler/api-error-handler';
import { ProfilePromoProductPage } from '../profile-promo-product/profile-promo-product';
import { Subscription } from 'rxjs';

@Component({
  selector: 'page-profile-promo-products',
  templateUrl: 'profile-promo-products.html',
  providers: [PromoProductsService]
})
export class ProfilePromoProductsPage {
  private subscription$: Subscription;
  @ViewChild(Refresher) refresher: Refresher;
  public promoProducts: PromoProductHistory[] = null;

  public loading: boolean = false;
  private userId: string = null;
  constructor(
    private promoProductService: PromoProductsService,
    private apiErrorHandler: ApiErrorHandlerProvider,
    public navCtrl: NavController
  ) { this.userId = localStorage.getItem('tuid'); }
  ionViewCanEnter(): void {
    this.loading = true;
  }
  ionViewDidEnter(): void {
    this.loading = true;
    this.subscription$ = this.promoProductService.getPromoProductsHistory(this.userId)
      .subscribe((products: PromoProductHistory[]) => {
        this.promoProducts = products;
        this.loading = false;
      }, ((error: HttpErrorResponse) => {
        this.loading = false;
        this.apiErrorHandler.handleError({ error })
      }))
  }
  openRewardsForProduct(product: PromoProductHistory) {
    this.navCtrl.push(ProfilePromoProductPage, { product: product })
  }
  pullToRefresh(event) {
    this.subscription$ = this.promoProductService.getPromoProductsHistory(this.userId)
      .subscribe((products: PromoProductHistory[]) => {
        this.promoProducts = products;
        this.refresher.complete()
      }, ((error: HttpErrorResponse) => {
        this.refresher.complete()
        this.apiErrorHandler.handleError({ error })
      }))
  }
  ionViewDidLeave(): void {
    this.subscription$.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile-promo-products/profile-promo-products.ts